import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../../utilities/appFetch';
import userRoutes from '../../../components/user/userRoutes';

const update = createAsyncThunk(
  'thunk/user/read',
  async (arg, thunkAPI) => {
    const response = await apiFetch(userRoutes.api.generate.read(arg?.id), {
      method: 'GET',
    });
    if (!response?.success) {
      return thunkAPI.rejectWithValue(response);
    }
    return response.result;
  },
);

export default update;
